// 공정 체크 화면 임시 확인용 페이지 (/case-check-preview)
// 목적: CaseCheckView 단독 확인 — 메뉴 노출 없음, config/features.qrCheck=true 일 때만 열린다.
// 저장하지 않는다(가짜 데이터 · 화면 상태만 변경). 정식 진입점 /q/:token 과 목록 아코디언은 작업 C·D에서.
import React, { useEffect, useState } from 'react';
import CaseCheckView from './CaseCheckView';
import { getFeatures } from '../utils/features';

// 가짜 케이스 (실제 환자 정보 아님)
const SAMPLE = {
    patientName: '홍길동',
    partnerName: '우리미소치과',
    selectedTeeth: ['16', '17'],
    processStage: 'milling',
    designDone: true,
    stageHistory: [
        { stage: 'scanning', at: '2026-08-08T09:12:00+09:00', source: 'auto' },
        { stage: 'designing', at: '2026-08-09T11:40:00+09:00', source: 'auto' },
        { stage: 'milling', at: '2026-08-09T14:20:00+09:00', source: 'auto' },
    ],
    visitDate: '2026-08-11T00:00:00+09:00',
    prosthesis: '지르코니아 크라운',
    material: '지르코니아',
    shade: 'A2',
    orderNumber: 'WO-2408-0192',
    createdAt: '2026-08-08T10:00:00+09:00',
    requests: '인접면 접촉 타이트하게',
    checks: {},
};

export default function CaseCheckPreview() {
    const [allowed, setAllowed] = useState(null);
    const [entity, setEntity] = useState(SAMPLE);

    useEffect(() => {
        let alive = true;
        getFeatures()
            .then(f => { if (alive) setAllowed(f?.qrCheck === true); })
            .catch(e => { console.error('공정 체크 미리보기: 플래그 조회 실패', e?.message || e); if (alive) setAllowed(false); });
        return () => { alive = false; };
    }, []);

    // 저장 없이 화면 상태만 바꾼다 (실제 저장은 작업 C에서 updateDoc)
    const handleToggle = async (key, next) => {
        setEntity(prev => ({
            ...prev,
            checks: {
                ...(prev.checks || {}),
                [key]: { done: next, at: next ? new Date().toISOString() : null, by: 'user', revertedFromAuto: !next && (key === 'scan' || key === 'mill') },
            },
        }));
    };

    if (allowed === null) return <div style={{ padding: 24, color: '#64748b' }}>{'불러오는 중…'}</div>;
    if (!allowed) return <div style={{ padding: 24, color: '#64748b' }}>{'준비 중인 화면입니다.'}</div>;

    return (
        <div style={{ padding: 20, background: '#f4f5f7', minHeight: '100vh' }}>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 12 }}>
                {'공정 체크 화면 미리보기 — 저장되지 않습니다 (가짜 데이터)'}
            </div>
            <div style={{ width: 344, maxWidth: '100%', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: 14 }}>
                <CaseCheckView entity={entity} onToggle={handleToggle} />
            </div>
        </div>
    );
}
